import { Box, Flex, Text, VStack, Heading } from '@everlywell/ui-kit';
import React from 'react';
import { IContentWithImage } from 'utils/types';

type WhyEverelyCareProps = {
  title: string;
  headline: string;
  disclaimer: {
    childMarkdownRemark: {
      html: string;
    };
  };
  listOfContentWithImages: IContentWithImage[];
};

const WhyEverelyCare: React.FC<WhyEverelyCareProps> = ({
  title,
  headline,
  disclaimer,
  listOfContentWithImages,
}) => (
  <Box py="5rem" maxWidth="750px" marginX="auto" px={[6, 0, 0]}>
    <VStack width="100%" spacing="0.5rem" align="center">
      <Heading
        as="h3"
        width="100%"
        textAlign="center"
        color="#28724F"
        fontSize="1rem"
        fontWeight={400}
        lineHeight="1.5rem"
        whiteSpace="nowrap"
      >
        {title}
      </Heading>
      <Heading
        as="h2"
        width="100%"
        textAlign="center"
        color="#0F0F0F"
        fontSize={['30px', '44px']}
        lineHeight={['1.25', '1.2']}
      >
        {headline}
      </Heading>
    </VStack>

    <VStack spacing={6} align="stretch" mt={10}>
      {listOfContentWithImages.map((item) => {
        let headingParts = item.heading?.split(/(\$|%)/g) || [];
        let coloredHeadingParts = headingParts.map((part) =>
          part === '$' || part === '%' ? (
            <Text
              as="span"
              key={part}
              color="#68CA9C"
              display="inline"
              fontSize="44px"
              fontFamily="heading"
              fontWeight="semibold"
            >
              {part}
            </Text>
          ) : (
            <Text
              as="span"
              key={part}
              fontFamily="heading"
              fontWeight="semibold"
              fontSize="56px"
            >
              {part}
            </Text>
          ),
        );

        return (
          <Flex
            key={item.heading}
            align={['left', 'center', 'center']}
            direction={['column', 'row', 'row']}
          >
            <Text
              color="#0F0F0F"
              minWidth="200px"
              fontWeight="semibold"
              fontFamily="heading"
              fontSize="50px"
            >
              {coloredHeadingParts}
            </Text>
            <Text fontFamily="body" textAlign="left">
              {item.description?.childMarkdownRemark?.rawMarkdownBody}
            </Text>
          </Flex>
        );
      })}
    </VStack>

    <Box
      mt={8}
      fontSize="xs"
      width="100%"
      textAlign="center"
      dangerouslySetInnerHTML={{
        __html: disclaimer?.childMarkdownRemark?.html || '',
      }}
    />
  </Box>
);

export default WhyEverelyCare;
